import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoogleadsenseComponent } from './simple-icons-googleadsense.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoogleadsenseComponent ],
    exports:      [ SimpleIconsGoogleadsenseComponent ],
    bootstrap:    []
})
export class SimpleIconsGoogleadsenseModule {}
